// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__3gpEf","logo":"Header_logo__3hVvj","textWrapper":"Header_textWrapper__BtpZW"};